export default "__VITE_ASSET__zwlFl7Cs__"